/**
 * home-animations.js — Urdile DS
 * - Fade-in + slide-up al entrar al viewport (IntersectionObserver)
 * - Parallax sutil en el hero banner
 * - Counter animado en stats-bar
 * - Brands track duplicado para loop infinito sin saltos
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {

    // ============================================================
    // 1. Fade-in scroll: agregar .animate-on-scroll a secciones de home
    //    automáticamente y observarlas
    // ============================================================
    var homeSections = document.querySelectorAll(
      '.template-index main > section, .template-index main > div > section'
    );

    homeSections.forEach(function(section, idx) {
      // El hero (primero) no se anima, ya está visible al cargar
      if (idx === 0) return;
      section.classList.add('animate-on-scroll');
    });

    // Observador único para todos los elementos animables
    var animateEls = document.querySelectorAll('.animate-on-scroll');
    if (animateEls.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -80px 0px'
      });

      animateEls.forEach(function(el) { io.observe(el); });
    } else {
      // Fallback si no hay IntersectionObserver
      animateEls.forEach(function(el) { el.classList.add('is-visible'); });
    }

    // ============================================================
    // 2. Parallax sutil en el hero
    //    Aplica solo si el hero existe y el usuario no prefiere reduced motion
    // ============================================================
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      var heroSlides = document.querySelectorAll('.hero-banner__slide');
      heroSlides.forEach(function(slide) { slide.setAttribute('data-parallax', ''); });

      var heroParallaxEls = document.querySelectorAll(
        '[data-parallax] .hero-banner__image, [data-parallax] .hero-banner__bg, [data-parallax] img'
      );

      if (heroParallaxEls.length) {
        var heroEl = document.querySelector('.hero-banner');
        var ticking = false;

        function updateParallax() {
          if (!heroEl) return;
          var rect = heroEl.getBoundingClientRect();
          // Solo aplicar parallax si el hero está visible
          if (rect.bottom < 0 || rect.top > window.innerHeight) {
            ticking = false;
            return;
          }
          var scrolled = window.pageYOffset;
          var translateY = scrolled * 0.18; // factor parallax suave
          heroParallaxEls.forEach(function(el) {
            el.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
          });
          ticking = false;
        }

        window.addEventListener('scroll', function() {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        }, { passive: true });
      }
    }

    // ============================================================
    // 3. Counter animado en stats-bar (números que cuentan)
    //    Detecta números como "30+", "500+", "2.400+", "#1"
    // ============================================================
    var statsBar = document.querySelector('.stats-bar');
    if (statsBar) {
      var statNumbers = statsBar.querySelectorAll('.stats-bar__number');
      statNumbers.forEach(function(el) {
        // Guardar el texto original
        var originalText = el.textContent.trim();
        // Extraer el número del texto (ej "2.400+" → 2400)
        var match = originalText.match(/[\d.]+/);
        if (!match) return; // Si no hay número (ej "#1"), no animar
        var numericStr = match[0].replace(/\./g, '');
        var targetNum = parseInt(numericStr, 10);
        if (isNaN(targetNum) || targetNum < 10) return;

        el.setAttribute('data-counter', '');
        el.setAttribute('data-target', targetNum);
        el.setAttribute('data-original', originalText);
      });

      var counterEls = statsBar.querySelectorAll('[data-counter]');
      if (counterEls.length && 'IntersectionObserver' in window) {
        var counterIO = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              counterIO.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        counterEls.forEach(function(el) { counterIO.observe(el); });
      }
    }

    function animateCounter(el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      var originalText = el.getAttribute('data-original');
      var duration = 1400; // ms
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        // easeOutCubic
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(target * eased);
        // Formatear con puntos miles si es >= 1000
        var formatted = current >= 1000
          ? current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          : current.toString();
        // Mantener el sufijo original (+, %, etc.)
        var suffix = originalText.replace(/[\d.]/g, '');
        el.textContent = formatted + suffix;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = originalText; // restaurar texto exacto al final
        }
      }
      window.requestAnimationFrame(step);
    }

    // ============================================================
    // 4. Brands loop infinito
    //    Duplicar el track de logos para que el loop CSS funcione sin saltos
    // ============================================================
    var brandsTrack = document.querySelector('.brands-section__track');
    if (brandsTrack && !brandsTrack.dataset.duplicated) {
      var children = Array.from(brandsTrack.children);
      children.forEach(function(child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        brandsTrack.appendChild(clone);
      });
      brandsTrack.dataset.duplicated = 'true';
    }

  });
})();
